<template>

  <div class="container d-flex align-items-center flex-column">
    <div class="row" v-if="loading">
        <div class="col-12 pt-2 loader-wrapper d-flex justify-content-center align-items-center">
          <div class="loader" ></div>
        </div>
    </div>

    <div v-if="[!loading & account]">
      <div class="row mt-5 pt-3" v-if="redeemCardPermission()">
        <div class="col-12 pt-5">
          <cta size="large" link="redeem"  text="Redeem a card" />
        </div>
      </div>

      <div class="row mt-5" v-if="account.show_sell_gift_card_pos && sellCardPermission()">
        <div class="col-12 pt-4" >
          <cta size="large" link="sell"  text="Sell a card" />
        </div>
      </div>
      <div class="row mt-5" v-if="ticketFeatureEnabled && redeemTicketPermission()">
        <div class="col-12 pt-4" >
          <cta size="large" link="scan"  text="Scan a ticket" />
        </div>
      </div>
    </div>
  
    <div class="alert_text" v-if="showSaveToHomescreen" >
    
       <img class="warning-icon" src="../assets/icons/warning.svg"/>

      <h4>Remember!</h4>
      <p>Save this to your home screen for easy access</p>
      <a href="http://academy.usetoggle.com/en/articles/2640548-adding-pos-mode-to-your-home-screen" target="_blank">Show me how</a>

    </div>
   
  </div>
</template>



<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){       
      return {
        loading:false
      };
  },
  created:function(){
      this.$store.commit("TWOFACTOR_STATUS",'');
      this.loading = true;
      this.$store.dispatch('updateConfig')
      .then()
      .catch( (error) => {
          this.$bus.$emit('error_message', error);
      }).then(() => {
          this.loading = false;
      });
  },
  computed:{
    showSaveToHomescreen(){
      return !window.matchMedia('(display-mode: standalone)').matches;
    },
    account(){
        return this.$store.getters.getAccount;
    },
    ticketFeatureEnabled() {
      if (!this.account){ 
        return this.forceRedirect()
      } else {
        return this.account.Features.data.filter(feature => feature.id === 4).length > 0;
      }
    },
  },
  methods:{
    /*
      * Force redirect to site page if the account data is not available
    */
    forceRedirect() {
      this.$router.push({ name: `site` });
    }
  }
}
</script>

<style lang="scss" scoped>

.redeem{
  margin-top: calc(25vh - 90px);
}

.sell {
  margin-top: calc(25vh - 10px);
}

.loader-wrapper {
  height: 90vh;
}


.alert_text{
  width:150px;
  .warning-icon{
    float:right;
    display:block;
    margin-bottom:10px;
  }
  h4{
    font-size: 1rem;
  }
  p,a,h4{
    float:right;
    clear:both;
    margin:0;
  }
  p,a{
    font-size: 0.9rem;
  }
  a{
    text-decoration: underline;
  }
  position: absolute;
  bottom:30px;
  right:30px;
  text-align: right;
}

</style>
